import { useState, useEffect } from "react";
import "./room.css";
import { fetchData } from "../firebaseConfig/fetcher";

const Room = () => {
  const [results, setResults] = useState([]);
  useEffect(() => {
    const interval = setInterval(async () => {
      setResults(await fetchData());
    }, 1000);
    return () => clearInterval(interval);
  }, [results]);

  return (
    <div>
      <h1 className="font-bold mb-6 mt-16 text-5xl">🔍 Who is in my room?</h1>

      <div className="header p-6 border-solid border-neutral-300 border-2 rounded-md mb-8">
        <div className="flex flex-row space-x-10 flex-wrap items-center">
          {results.map((result, i) => (
            <div className="patient pb-6" key={i}>
              <img
                className="p-1 w-20 h-20 rounded-full ring-2 ring-gray-300 dark:ring-gray-500"
                src={result.data.img}
                alt="Bordered avatar"
              ></img>
              <div className="flex flex-col pl-2.5">
                <h1 className="text-3xl font-bold name1">
                  {result.data.flname}
                </h1>

                <h3 className="text-xl mr-2">
                  {result.data.pos} — {result.data.timestamp}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Room;
